import { AfterViewInit, Directive, ElementRef, EventEmitter, Output, Renderer2 } from '@angular/core';
import { HelpTopicService } from '../services/help-topic.service';

@Directive({
    selector: '[helpTopicBadge]',
    standalone: false
})
export class HelpTopicBadgeDirective implements AfterViewInit {
  @Output() badgeClick = new EventEmitter<void>();

  constructor(private el: ElementRef, private renderer: Renderer2, private helpTopicService: HelpTopicService) {}

  ngAfterViewInit(): void {
    // The badge element is generated inside the host element with a specific class
    const badgeElement = this.el.nativeElement.querySelector('.mat-badge-content');

    if (badgeElement !== undefined) {
        badgeElement.style.pointerEvents = 'inherit'; // Necessary to enable pointer events
        badgeElement.style.cursor = 'pointer';
        badgeElement.addEventListener('click', (e) => {
          const elementRect = badgeElement.getBoundingClientRect();
          const helpTopicKey = e.srcElement !== undefined ? e.srcElement.innerText : e.innerText;
          this.helpTopicService.openHelpTopicViewerDialog(null, helpTopicKey, elementRect);
      });
    }
  }
}